import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Species.css";

/**
 * Species component renders a list of plant species found in Sundarbans.
 * It includes a search bar to filter species by English or Bangla names.
 */
function Species({ setTree }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [speciesList, setSpeciesList] = useState([]);

  // Fetch species list from backend
  useEffect(() => {
    const fetchSpecies = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/speciesIdList`
        );
        if (!response.data.error) {
          setSpeciesList(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching species list:", error);
      }
    };
    fetchSpecies();
  }, []);

  // Handle click on species
  const handleClick = (id) => {
    setTree(id);
    window.location.href = "/tree";
  };

  // Handle search
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filter by search
  const filteredSpeciesList = speciesList.filter((species) => {
    const searchLower = searchQuery.toLowerCase();

    const nameEn = species.name_en?.toLowerCase() || "";
    const nameBn = species.name_bn || "";

    return nameEn.includes(searchLower) || nameBn.includes(searchLower);
  });

  return (
    <div className="species">
      <div className="flora">Sundarban's Flora</div>
      <input
        type="text"
        className="search-bar"
        placeholder="Search 'English or Bangla Names'..."
        value={searchQuery}
        onChange={handleSearchChange}
      />
      <ul className="spc-list">
        {filteredSpeciesList.map((species) => (
          <li
            key={species.id}
            onClick={() => handleClick(species.id)}
            className="spc-item"
          >
            <div className="spc-img-container">
              <img
                src={species.thumbnail}
                alt={species.name_en}
                loading="lazy"
              />
            </div>
            <div className="spc-info">
              <label>{species.name_en}</label>
              <p>{species.name_bn}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Species;
